import React from 'react';
import { Character } from '../api/characters';
import { getLevelProgress } from '../utils/xp';

interface CharacterCardProps {
  character: Character;
  onActivate: (id: string) => void;
  isActivating: boolean;
}

const CharacterCard: React.FC<CharacterCardProps> = ({ character, onActivate, isActivating }) => {
  const progress = getLevelProgress(character.xp, character.level);

  return (
    <div className={`character-card ${character.is_active ? 'active' : ''}`}>
      <div className="character-avatar">
        <img src={character.avatar_url || '/avatars/base-1.svg'} alt={character.name} />
      </div>
      <div className="character-name">
        {character.name}
        {character.is_active && <span className="active-indicator">Active</span>}
      </div>
      <div className="character-level">Lv. {character.level}</div>
      <div className="xp-bar-container">
        <div className="xp-bar" style={{ width: `${progress.percent}%` }} />
      </div>
      <div className="xp-text">
        {character.xp} XP
      </div>
      <div className="xp-text-secondary">
        {progress.nextLevelAt ? `Next level at ${progress.nextLevelAt} XP` : 'Max level'}
      </div>
      {character.is_active ? (
        <button className="character-btn character-btn-active" disabled>
          Current Character
        </button>
      ) : (
        <button
          className="character-btn character-btn-primary"
          onClick={() => onActivate(character.id)}
          disabled={isActivating}
        >
          {isActivating ? 'Switching...' : 'Use This Character'}
        </button>
      )}
    </div>
  );
};

export default CharacterCard;
